import React from 'react';
import { Route, IndexRedirect } from 'react-router';
import { Tracking } from 'web-core/src/tracking';
import TranslationProvider from 'client/components/translationProvider';
import LoginPage from './login';
import CreatePage from './create';
import ResetPage from './reset';
import RequestResetPage from './requestResetPage';
import App from './app';

function bindPageViewTracking() {
  return () => {
    Tracking.trackPageView();
  };
}

/* eslint-disable quote-props */
export const redirectRouteToPathMapping = {
  'purchase': 'hero.plan',
};

export const sourceToPathMapping = {
  'deduction-guide': 'hero.deductionGuide',
  'deduction-guide-job-select': 'hero.deductionGuideJobSelect',
  'airbnb-tax-help': 'hero.freeTaxHelp',
};
/* eslint-enable */

// TODO: move translations to account.json once vision funnel is using unified login
export default (
  <Route path="/" component={App}>
    <Route component={TranslationProvider} keys={['common']}>
      <IndexRedirect to="/login" />
      <Route
        path="login"
        component={LoginPage}
        onEnter={bindPageViewTracking()} />
      <Route
        path="create"
        component={CreatePage}
        onEnter={bindPageViewTracking()} />
      <Route
        path="request-reset"
        component={RequestResetPage}
        onEnter={bindPageViewTracking()} />
      <Route
        path="reset/:email/:code"
        component={ResetPage}
        onEnter={bindPageViewTracking()} />
    </Route>
  </Route>
);
